import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "We provide WordPress development that's fast, secure and genuinely easy for your team to manage — no page-builder bloat, no fragile plugin stacks. Custom themes and plugins are built to match your brand and your workflow exactly.",
    "Whether you need a marketing site, a content platform or a custom CMS build on WordPress, we deliver something your editors will actually enjoy using.",
];

const FEATURES = [
    { title: "Custom theme development", text: "Pixel-accurate themes coded from your design, not stretched from a template." },
    { title: "Custom plugin development", text: "Bespoke functionality built the WordPress way, so updates never break it." },
    { title: "CMS & content workflows", text: "Clean editing experiences your team can run without a developer." },
    { title: "Maintenance & support", text: "Updates, backups, security and performance handled on an ongoing basis." },
];

const CHECKS = [
    "WordPress web development",
    "CMS development",
    "Custom plugin development",
    "Theme development",
    "Maintenance & support",
];

export default function WordpressDevelopment() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="CMS & Migration" title="WordPress Development" eyebrowAs="span">
                    Cutting-edge, quality-driven and user-friendly WordPress builds — your own stylish site, fully under your control.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
